import * as React from 'react'
// libs
import moment from 'moment'
// hooks
import { useShowModal } from 'hooks'
// components
import { HoverablePopover } from 'components/UI'
import TableRow from '@mui/material/TableRow'
// constants
import { Modals } from 'constants/index'
import { ISecurityGroup } from 'types/graphql'
// themes
import { EllipsizedText } from 'themes/views/generic'
// views
import { CheckedIcon, TableCell, TEXT_STYLE } from 'themes/views/tables'

interface Props {
  data: ISecurityGroup
}

const Row: React.FC<Props> = ({ data }) => {
  const { active, createdAt, id, name } = data

  const { showModal } = useShowModal({ modalType: Modals.GROUP_SECURITY_MODAL })

  const showGroupSecurityModal = () => showModal({ groupSecurity: data, isEdit: true })

  return (
    <TableRow key={id} hover>
      <TableCell size={20}>
        <HoverablePopover
          trigger={
            <EllipsizedText
              data-testid='group-security'
              data-entity-id={id}
              onClick={showGroupSecurityModal}
              style={TEXT_STYLE}>
              {name}
            </EllipsizedText>
          }>
          {name}
        </HoverablePopover>
      </TableCell>
      <TableCell size={10}>{moment(createdAt).format('D/MM/YYYY')}</TableCell>
      <TableCell size={5}>{active && <CheckedIcon />}</TableCell>
    </TableRow>
  )
}

export default Row
